module.exports = __webpack_public_path__ + "static/media/foodshot8.bf161064.JPG";